<ng-template let-modal #claimReferal>
  <div class="d-flex flex-column justify-content-center align-items-center p-3">
    <div style="font-size: 1.5rem; font-weight: bold; text-decoration: underline" class="mb-4">Enter Shop Promo Code</div>
    <div class="d-flex">
      <div class="mr-2" style="border-radius: 50%; overflow: hidden">
        <img src="../../../../../assets/images/w.jpeg" />
      </div>
      <div class="w-100 d-flex justify-content-center flex-column align-items-center">
        <input style="max-width: 20em" type="text" placeholder="Shop Promo Code" class="form-control" [(ngModel)]="claimPromoCode" />
        <button (click)="claimCurrentMoreSerive()" class="my-button-3 mt-3"><i class="fa fa-check"></i> Claim</button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #seeProductList let-modal>
  <p class="mb-4 p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i [class]="productListIcons"></i>{{ productListTitle }}</p>

  <div class="prods p-4">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view [isSelected]="true" [canBeSelected]="isSearchProductsOnBookmark" (selected)="searchProductSelected($event, list)" (view)="goToProduct($event)" [list]="list" [isCommunityProduct]="true"> </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i class="fas fa-heart-broken"></i> No products found in this category</p>
  <button class="btn btn-outline-primary m-3 btn-sm" (click)="closeActiveModal()">Close</button>
</ng-template>

<ng-template let-modal #addAdsInProduct>
  <div class="w-100 d-flex justify-content-center align-items-center">
    <div class="more-services p-2 flex-column align-items-center p-4">
      <div class="more-service w-100 mb-2">
        <div class="d-flex flex-column" style="position: relative">
          <app-icon-selector (iconChange)="newPromoIconText = $event" style="position: absolute; top: 0; left: 0" [nowValue]="newPromoIconText" [icons]="moreServiceIcons"></app-icon-selector>

          <!-- Image Display Conditions -->
          <ng-container *ngIf="newPromotSelectedImageConverted; else defaultImage">
            <img class="more-service-img mr-2" [src]="newPromotSelectedImageConverted" (click)="selectMoreImageNewPromoImage()" />
            <span class="delete-img">
              <i class="fa fa-trash" (click)="deleteNewPromoImage()" aria-hidden="true"></i>
            </span>
          </ng-container>

          <ng-template #defaultImage>
            <img class="more-service-img mr-2" style="max-height: 50%; width: auto" src="../../assets/images/uploadd2.png" (click)="selectMoreImageNewPromoImage()" />
          </ng-template>

          <input type="file" (change)="setImageOfMoreService($event)" style="visibility: hidden; width: 0" [id]="newPromoImageSelectorId" />
        </div>

        <div class="d-flex flex-column more-service-middle">
          <div class="d-flex justify-content-start align-items-center mt-2">
            <input maxlength="40" (change)="newPromoServiceComment = $event.target.value" [value]="newPromoServiceComment" class="form-control mb-2" rows="2" placeholder="Enter Information about the service." />
          </div>

          <textarea maxlength="255" (change)="newPromoServiceDescription = $event.target.value" placeholder="Enter more description about the service." class="form-control mb-2 mt-2" rows="2" style="height: 10em">{{ newPromoServiceDescription }}</textarea>

          <div class="my-2 w-100 d-flex">
            <div class="d-flex h-100 flex-column justify-content-center">
              <label for="select-expiry" style="color: var(--primary)">Select Expiry:</label>
            </div>
            <div>
              <select (change)="expiryStringChanged($event, i)" class="select-expiry ml-2">
                <option *ngFor="let val of availableExpiryIntervals" class="p-2" [value]="val" [selected]="val == newPromoExpiryInString">
                  {{ val }}
                </option>
              </select>
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-primary mt-1 w-100" (click)="saveNewPromoOnProduct()">Save</button>

          <input *ngIf="newPromoAllowRefer" (change)="newPromotReferAmount = $event.target.value" [value]="newPromotReferAmount" type="number" placeholder="$" class="mt-1 mb-1 form-control" />
        </div>
      </div>
    </div>

    <div class="px-2 w-100 h-100 d-flex flex-column justify-content-center">
      <div class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 0">
        <input type="checkbox" class="mr-2" id="allowRefer" [checked]="newPromoAllowRefer" (change)="newPromoAllowRefer = $event.target.checked" />
        <label for="allowRefer" style="margin-bottom: 0">Allow users to refer this product</label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-modal #whyReferExplanation cla>
  <div class="w-100 h-100 d-flex flex-column justify-content-start p-4 refer-explanation-modal">
    <p class="w-100 title">You need to refer some friend before claiming this service</p>
    <div class="w-100 d-flex">
      <div class="mr-2" style="border-radius: 50%; overflow: hidden">
        <img src="../../../../../assets/images/w.jpeg" />
      </div>
      <div class="p-3 steps">
        <p class="mb-1" style="font-weight: bold">Inorder to claim services you need to refer(send your referal link) to users and they must claim</p>
        <p class="mb-2">Here are the step to claim a service:</p>
        <div>
          <p>1&#41; Send the referal link below to your friends</p>
          <p>2&#41; For each friend that claim the a service using your link you get a chance to claim a service!</p>
        </div>

        <div class="d-flex justify-content-center flex-column align-items-start mt-2">
          <span style="padding: 1em 2em; border: 3px dashed var(--primary); color: black; border-radius: 10px" class="mb-4"> {{ getMoreServiceRefferalLink(productData) }}</span>
          <div class="d-flex w-100 justify-content-center" style="font-size: 0.8em">
            <button (click)="copy(getMoreServiceRefferalLink(productData))" class="my-button-3 mr-2"><i class="fa fa-copy"></i> Copy</button>
            <button (click)="share(getMoreServiceRefferalLink(productData))" class="my-button"><i class="fa-brands fa-whatsapp"></i> Share</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="custom-swiper-1">
  <app-my-carousel-swiper cssClass="custom-swiper-1" (onSlideChange)="productSwiperChanged($event)">
    <div class="swiper-slide">
      <div *ngTemplateOutlet="productDetailsTempalte; context: { productData: productData }"></div>
    </div>
    <div class="swiper-slide" *ngFor="let prod of similarProducts">
      <div *ngTemplateOutlet="productDetailsTempalte; context: { productData: prod }"></div>
    </div>
  </app-my-carousel-swiper>
</div>

<ng-template let-productData="productData" #productDetailsTempalte>
  <div class="modal-body my-prod-detail" id="wrapper" style="position: relative">
    <span *ngIf="productData && (productData['attachmentProducts'] || productData?.prevProduct)" class="attach-item"> <i class="fa fa-plus" aria-hidden="true"></i>2</span>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="my-prod-detail__favorite" (click)="handleFavoriteProduct(productData)">
        <i [class]="productData?.isFavorite ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      </div>

      <div class="my-prod-detail__body product_detail_body {{ productData?.appUser?.bgBody ?? '' }}">
        <div class="grid-image">
          <div style="position: relative; overflow: hidden">
            @if (isThereValidCropInformation && productData?.food_image_active == productData?.food_image_1) {
              <app-cropped-image [imgSrc]="imgUrl + productData?.food_image_active" [cropInformation]="productData?.mainImageCropInformation" [imgAlt]="'Image ' + productData.name" (click)="viewProductDetails(productData)"></app-cropped-image>
            } @else {
              <img loading="lazy" class="main-image" [src]="imgUrl + productData?.food_image_active" (error)="handleError($event)" />
            }

            <!--  -->
            <div class="verified" *ngIf="isVerified">
              <!-- <i class="fa fa-medal"></i>  -->
              <span [style]="verifiedStyle"  class="d-flex align-items-center" (click)="moduloIncreaseVerifiedRating()">
                <span>{{ verifiedTag | titlecase }}</span>
                <div class="rhoumbus-outer ">
                     
                  <div class="rhoumbus-inner" [style.width.%]="(productData?.verifiedTagRating / 3) * 100"></div>
                </div>
              </span>
            </div>
          </div>

          <div class="slide-images">
            <ng-container *ngFor="let image of [productData?.food_image_1, productData?.food_image_2, productData?.food_image_3, productData?.food_image_4]">
              <div *ngIf="image != ''" (click)="changeShowImageProduct(productData, image)" (error)="handleError($event)" [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
            </ng-container>
          </div>
        </div>
        <div class="my-prod-detail__body--content">
          <div *ngIf="productLoader; else productDetail" class="d-flex flex-column justify-content-center text-center">
            <div class="spinner-border text-primary mx-auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            Loading...
          </div>
          <ng-template #productDetail>
            <div class="row">
              <div class="col-md-12">
                <div class="my-prod-detail__body--content__title flex-column" style="margin-bottom: 0.75rem; position: relative">
                  <div class="shop_name w-100">
                    <div class="d-flex w-100 justifiy-content-start">
                      <h1 class="text flex-wrap w-100 overflow-hidden" style="font-size: 1em" [ngbTooltip]="screenWidth > 767 ? 'Go to ' + productData?.name + ' Detail' : null" style="cursor: pointer" (click)="openProductPage(productData)" tooltipClass="my-tooltip">
                        <span class="prod-name" style="display: inline">{{ productData?.name }}</span>
                        <ng-container *ngIf="productData?.companyName && productData?.companyName != 'null'">
                          by <span class="company-name-word" *ngFor="let word of productData?.companyName?.split(' ')"> {{ word }}</span>
                        </ng-container>
                        <span class="price" *ngIf="productData?.type != 'promote'">{{ priceCheck(productData?.foodSpecs?.[0]?.key || "0") }}</span>
                      </h1>
                      <div class="ml-2" style="font-size: 0.8em; color: var(--primary); cursor: pointer" *ngIf="showReferProductIcon && isLogin" id="refer-btn" (click)="openShareReferLink(productData)">
                        <!-- <img style="width: 2em" src="../../../../assets/images/new/refer_friend_new.png" /> -->
                      </div>
                    </div>
                  </div>
                </div>
                <app-my-carousel-swiper [navigation]="productData?.recommendedPins ? true : false" *ngIf="!isLoading && (productData?.recommendedPins || productData?.ratings?.length || productData?.otherRatingBadges?.length)" [config]="carouselOptions" class="transparent-swiper">
                  <ng-container *ngIf="productData?.recommendedPins">
                    <div class="swiper-slide" *ngFor="let pin of productData?.recommendedPins ?? []">
                      <div class="experience" (click)="openRecommendation(pin)">
                        <div class="text" style="display: inline">{{ pin.message }}</div>
                        <button class="ml-1" (click)="$event.stopPropagation(); isReading ? pause() : read(pin.message)" style="background: transparent; border: 0px; color: var(--secondary); font-size: 0.8em; font-weight: bold; width: 2rem; height: 2rem; display: inline-flex; justify-content: center; align-items: center">
                          @if (isReading) {
                            <i class="fa-solid fa-pause"></i>
                          } @else {
                            <i class="fa-solid fa-play"></i>
                          }
                        </button>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="productData?.ratings?.length || productData?.otherRatingBadges?.length">
                    <div class="swiper-slide position-relative" (touchstart)="$event.stopPropagation()" style="overflow: hidden; overflow-x: scroll">
                      <div class="all-reviews" *ngIf="productData">
                        <ng-container *ngFor="let rating of productData?.ratings">
                          <div class="seller-info" *ngIf="rating.rating || rating.counts" (click)="openCorrectedSite(rating.ratingUrl)">
                            <img [src]="'../../../../../assets/images/' + rating.icon" class="rating-img" style="width: 2.5rem" />
                            <div class="rating">{{ rating.rating | number: "1.1-1" || 0 }}</div>
                            <div class="star-rating">
                              <div class="stars-outer">
                                <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                              </div>
                            </div>
                            <div class="rating-name">
                              <span class="number">
                                {{ rating.counts || 0 }}
                              </span>
                              <span>Reviews</span>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container *ngFor="let rating of productData?.otherRatingBadges">
                          <div class="seller-info position-relative" [class.mb-3]="rating.isNormalBadge && !isMobile" *ngIf="rating.rating || rating.text || rating.isNormalBadge" [ngbTooltip]="rating.toolTip" container="body" tooltipClass="my-tooltip tooltip-above">
                            <img [class.rating-img]="!rating.isNormalBadge" [class.normal-badge]="rating.isNormalBadge" [src]="'../../../../../assets/images/' + rating.icon" style="width: 2.5rem; height: 3.5rem" />
                            @if(rating.isNormalBadge){
                              <div class="d-flex flex-column align-items-center position-relative normal-badges" >
                                <div class="seller-info-top-text">
                                  {{rating.topText}}
                                </div>
                                <div class="seller-info-bottom-text">
                                  {{rating.bottomText}}
                                </div>
                                
                              </div>

                            }@else{
                              <div class="position-relative d-flex flex-column align-items-center" style="top: -0.25rem">
                                <div class="rating" >{{ rating.rating | number: "1.1-1" || 0 }}</div>
                                <div class="star-rating" >
                                  <div class="stars-outer">
                                    <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                                  </div>
                                </div>
                                <div class="rating-name position-relative">
                                  {{ rating.text }}
                                </div>
                              </div>

                            }

                          
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </app-my-carousel-swiper>

                <div class="detail-text">
                  <app-my-tabs [tabs]="productData?.tabsInfo" (tabChange)="clickTab($event)" design="4">
                    <!-- Info -->
                    <div class="mb-2" tab0>
                      <div class="mb-2" *ngIf="productData?.tags?.length || productData?.productTypes?.size">
                        <ng-container *ngFor="let tag of productData.tags">
                          <button *ngIf="tag.addCount" (click)="isLogin ? (tag.isAddedByMe ? removeTagFromProduct(tag) : addTagToProduct(tag)) : showLoginError('add a tag')" [class.active]="tag.isAddedByMe" class="btn btn-outline-primary btn-sm mr-1 mt-1">{{ tag.tag }}</button>
                        </ng-container>
                        <ng-container *ngFor="let type of productData.currentProductCategoryAvailableTypes">
                          <button (click)="openSimilarProducs(type)" *ngIf="productData.productTypes.has(type.id)" class="btn btn-outline-primary btn-sm mr-1 mt-1" style="border-color: var(--secondary); color: var(--secondary)">{{ type.name }}</button>
                        </ng-container>
                        <!-- <button  class="btn btn-outline-primary btn-sm" (click)="openSuggestionPopupAndRefresh()">Add Tag</button> -->
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <div class="d-flex" style="gap: 5px">
                          <div *ngFor="let report of productData?.reports ?? []">
                            <span class="badge badge-danger">
                              <span *ngIf="roleService?.roles?.userType?.includes('ADMIN')" style="cursor: pointer" (click)="deleteReport(report.type)">
                                <i class="fa-solid fa-times"></i>
                              </span>
                              {{ report.type }} {{ roleService?.roles?.userType?.includes("ADMIN") && report.typeCount > 1 ? report.typeCount : "" }}
                            </span>
                          </div>
                        </div>

                        <!--When location tab is active no need to show this so the second condiction checks that-->
                        @if ((productData?.appUser?.regionName || productData?.type == "promote") && !((productData?.type == "promote" && productData?.latLong != "{}" && productData?.latLong != null) || (productData?.type != "promote" && productData?.appUser?.postalCode != null))) {
                          <button class="btn btn-outline-primary btn-sm">
                            {{ productData?.type == "promote" ? (productData?.subRegionName == "all" ? "Doorstep" : productData?.subRegionName) : productData?.appUser?.regionName }}
                          </button>
                        }
                      </div>
                      <div class="product-description" [class.active]="productSeeMore" [innerHTML]="formattedText(productData, 'description')" #product_content></div>

                      <div class="text-center mt-3">
                        <button *ngIf="productData?.type == 'promote' && productData.shoutInfo && productData.shoutInfo != 'null'" class="btn btn-outline-primary btn-sm">
                          {{ productData.shoutInfo }}
                        </button>
                      </div>
                      <div (click)="productSeeMore = !productSeeMore" class="scroll-arrows-description" *ngIf="canScrollDescription">
                        <button class="scroll-arrow">
                          <span>See More</span>
                          <i [class.down]="!productSeeMore" class="fa-solid fa-chevron-up"></i>
                        </button>
                      </div>
                    </div>
                    <!-- Info -->
                    <!-- Details -->
                    <div class="mb-2" tab1>
                      <div [innerHTML]="formattedText(productData, 'charges')"></div>
                    </div>
                    <!-- Details -->
                    <!-- Price -->
                    <div tab2>
                      <div class="mt-2" *ngIf="productData?.foodSpecs?.length > 0">
                        <div class="d-flex justify-content-between align-items-center pb-2">
                          <div>PRODUCT VARIANTS</div>
                        </div>

                        <textarea *ngIf="isBookNowBox" matInput formControlName="message" class="form-control mb-2 mt-2" (change)="onChangeBookNowMessage($event)" rows="5" placeholder="Write Remarks..." required></textarea>

                        <button *ngIf="isBookNowBox" (click)="bookNow(productData, productData?.id, productData?.name, productData?.adminId, productData.seller?.first_name, productData.seller?.w_phone_number)" class="btn btn-purple mb-2" [disabled]="isLoading">Send</button>

                        <table class="table table-sm mt-2">
                          <thead>
                            <tr class="text-nowrap">
                              <th scope="col">Name</th>
                              <th scope="col">Details</th>
                              <th scope="col" width="15%">Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let variants of productData?.foodSpecs">
                              <td>{{ variants.value }}</td>
                              <td>{{ variants.nKey ? variants.nKey : "-" }}</td>
                              <td>${{ variants.key }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!-- Price -->
                    <!-- Rent -->
                    <div tab3 class="mt-4">
                      <div class="mb-3" *ngIf="productData?.depositAmt"><b>Deposit Amount : </b><i class="fa fa-usd" aria-hidden="true"></i> {{ productData?.depositAmt }}</div>
                      <img *ngIf="productData?.seller?.showCardOnProducts" loading="lazy" [disabled]="isLoading" (click)="buyNow(productData?.id, productData?.name, productData?.adminId, productData?.depositAmt, productData?.estimateValue)" src="../../../assets/images/ccc.png" style="float: right; width: 60px; margin-top: -55px" />

                      <div class="mb-3" *ngIf="productData?.estimateValue"><b>Estimate Value : </b><i class="fa fa-usd" aria-hidden="true"></i> {{ productData?.estimateValue }}</div>
                      <div class="mb-3" *ngIf="productData?.warranty"><b>Warranty Left : </b>{{ productData?.warranty }} Months</div>
                    </div>
                    <!-- Rent -->
                    <!-- Shout Contact -->
                    <div tab4 class="mt-4">
                      <!-- @if(isLogin == 1){ -->
                      <div class="mb-3" *ngIf="productData?.shoutContact && productData?.shoutContact.length === 10">
                        <b>Contact Number : </b>
                        <i class="fa-brands fa-whatsapp" style="color: purple" aria-hidden="true"></i>
                        <a style="color: purple" [href]="'https://wa.me/' + productData?.shoutContact" target="_blank"> WhatsApp </a>
                      </div>
                      <div class="mb-3" *ngIf="productData?.shoutContactRelation && productData?.shoutContactRelation != 'null'"><b>Contact Relationship : </b><i class="fa fa-users" aria-hidden="true"></i> {{ productData?.shoutContactRelation }}</div>
                      <div class="mb-3" *ngIf="productData?.shoutWebsite?.trim() && productData?.shoutWebsite != 'null'">
                        <b>Contact Website : </b> <a style="color: purple" [href]="prodSite" target="_blank">{{ prodSite }}</a> <span *ngIf="productData?.isOutdated" class="text-danger ml-2">(Outdated)</span>
                      </div>
                      <!-- } -->
                    </div>
                    <!--Shout Contact -->
                    <!-- Location -->
                    <div tab5 class="mt-4 d-flex flex-column">
                    
                      <div class="d-flex justify-content-between w-100  mb-2" style="align-self: flex-start">
                        <span  class="btn btn-sm btn-outline-primary" *ngIf="positionString">{{ positionString }}</span>
                        <div class="d-flex align-items-center"> 
                          <input type="checkbox"  [(ngModel)]="productData.isPopuplarInSubRegion"  [id]="'pop-sub-rgn' + productData?.name" *ngIf="productData && isAdmin()" (change)="currentProductTogglePopuplarInSubRegion()">
                          <label style="margin: 0; margin-left: .5em;" [for]=" 'pop-sub-rgn' + productData?.name">Popular in Subregion</label>
                        </div>

                      </div>
                      <div id="map_biz" class="map mt-2" style="height: 280px"></div>
                    </div>
                    <!--Location -->
                  </app-my-tabs>
                </div>
              </div>

              <!-- <div class="col-md-4" style="border-left: 1px solid rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.25)">
                <app-my-tabs [tabs]="productData?.tabs" design="3" [defaultTabIndex]="1" [slider]="true">
                  <div tab3>
                    <div class="row product_detail_promo px-2">
                      <div class="col-6 p-0" *ngFor="let row of productData?.more_products_data">
                        <div class="card mb-3 border-0 h-100" (click)="redirectToProduct(row)">
                          <div class="d-flex flex-column no-gutters">
                            <div class="container-img">
                              <img loading="lazy" src="{{ imgUrl }}{{ row?.foodImages ? row?.foodImages[0].image : row?.memberShopProductsImages[0].image }}" class="border-0 p-0 w-100" alt="..." />
                            </div>
                            <div class="pl-2 pt-1">
                              <p style="font-size: 13px; line-height: 13px" class="font-bold">
                                {{ row.name }}
                              </p>
                              <div>
                                <p class="price" style="font-size: 13px; line-height: 13px">${{ row.foodSpecs ? row.foodSpecs[0].key : row.memberShopProductsVariations[0].key }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div tab0 style="display: flex; flex-direction: column; justify-content: start; align-items: start; margin-top: 0.5rem">
                    <ng-container *ngFor="let item of productData?.productVerficationsList">
                      <div *ngIf="item != ''" class="py-1">
                        <div class="d-flex flex-row justify-content-between align-items-start">
                          <h3>
                            <div style="color: rgb(51, 1, 51); font-size: 1.1rem; font-weight: bold">
                              <span class="mr-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8A2BE2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                  <path d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" fill="#8A2BE2" stroke="none" />
                                  <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </span>

                              {{ item.value }}
                              <button [class.reaction-liked]="item.haveILiked" (click)="toggleVerifyLike(item)" class="ml-1 align-items-center rxn" style="background: transparent; display: inline-flex">
                                <span *ngIf="!item.likeCounts">+</span>
                                <span *ngIf="item.likeCounts" style="font-weight: bold; position: relative">
                                  <i class="fa fa-thumbs-up"></i>
                                  <span class="mr-1" *ngIf="item.likeCounts > 1" style="position: absolute; font-size: 0.7rem; top: 0px; right: -0.6rem">{{ item.likeCounts }}</span>
                                </span>
                              </button>
                            </div>
                          </h3>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div tab1 class="more-services">
                    <ng-container *ngFor="let item of productData?.productMoreServices">
                      <div *ngIf="item && item.serviceComment" class="py-1 shadow-sm p-2 w-100 mb-2" style="aspect-ratio: 0.8; position: relative; background: var(--primary); border-radius: 10px" (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription) : ''">
                        <div class="d-flex flex-column justify-content-start align-items-start" style="height: 100%">
                          <div style="color: rgb(51, 1, 51); font-size: 1.1rem; font-weight: bold; height: auto; max-width: 100%" class="d-flex align-items-center justify-content-end mb-1"></div>

                          <div class="cnt">
                            <div style="height: 70%; position: relative" class="d-flex flex-column justify-content-start">
                              <div style="max-height: calc(100% - 1.3rem); overflow: hidden">
                                <img [src]="imgUrl + item.imageFile" style="width: 100%" (error)="handleError($event)" />
                              </div>

                              <div>
                                <span>{{ item.serviceComment }}</span>
                              </div>
                              <div style="position: absolute; top: 0; right: 0">
                                @if(item.iconText?.trim()){
                                <app-icon-selector [nowValue]="item.iconText" [icons]="[]" [selectionEnabled]="false"></app-icon-selector>
                                }
                              </div>
                            </div>

                            <div class="w-100 d-flex justify-content-between">
                              <div>
                                @if(item.allowRefer){
                                <span class="ml-1 price-text">{{ !item.referAmount || item.referAmount == "0" ? "FREE" : "$" + item.referAmount }}</span>
                                }@else{
                                <div style="width: 1px"></div>
                                }
                              </div>

                              @if (item.allowRefer) { @if (!profileInfo2?.linkReferedCount && !linkRfererUserId && isLogin) {
                              <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
                              } @else { @if (isLogin) {
                              <button (click)="$event.stopPropagation(); claimMoreService(item)" class="my-button-3 below-btn">Claim</button>
                              } @else {
                              <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Login</button>
                              } } }
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div tab2>
                    <div class="d-flex w-100 justify-content-center mt-3 align-items-center" style="color: var(--primary); flex-wrap: wrap">
                      <div *ngIf="productData?.seller_info?.fbUrl" class="">
                        <a [href]="correctSite(productData?.seller_info?.fbUrl)" target="_blank"> <i class="fa-brands fa-facebook-f"></i></a>
                      </div>
                      <div *ngIf="productData?.seller_info?.instagramUrl" class="mr-3 ml-3">
                        <a [href]="correctSite(productData?.seller_info?.instagramUrl)" target="_blank">
                          <i class="fa-brands fa-instagram"></i>
                        </a>
                      </div>

                      <div *ngIf="productData?.seller_info?.websiteUrl" class="d-flex mr-2">
                        <span
                          ><a [href]="correctSite(productData?.seller_info?.websiteUrl)" target="_blank" style="color: var(--primart)"> <i class="fa-solid fa-globe"></i> </a
                        ></span>
                      </div>
                    </div>
                    <ng-container *ngIf="productData?.enableMemberShop && (productData?.type != 'promote' || (productData?.type == 'promote' && (!productData?.shoutImage || !productData?.shoutName)))">
                      <popper-content #tooltipcontent>
                        <div class="popper-content">
                          <app-biz-owner-popup *ngIf="productData?.memberId" [inputId]="productData?.memberId"></app-biz-owner-popup>
                        </div>
                      </popper-content>
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body">
                          <div class="text-center">
                            <div class="d-flex justify-content-center">
                              <i class="fa-solid fa-calendar" (click)="openHolidayPopUp(HolidayPopup)" style="position: relative; left: 7rem; color: #cc6767"></i>

                              <div style="position: absolute; left: 1.25rem">
                                <div class="d-flex flex-column">
                                  <ng-container *ngFor="let item of productData?.appUser?.appUserCertificates; let i = index">
                                    <img loading="lazy" src="{{ imgUrl }}public/images/certificate/{{ item.role }}.png" style="height: 1.5rem; width: 1.5rem; border-radius: 50%" />
                                  </ng-container>
                                </div>
                              </div>
                              <div>
                                <img loading="lazy" (click)="goToProfileDetail()" [popper]="tooltipcontent" [popperTrigger]="screenWidth > 767 ? 'hover' : 'click'" [popperPlacement]="'right'" src="{{ local.checkImageProfile(productData?.appUser) }}" class="shadow-sm rounded-circle border char-image" style="width: 85px; height: 85px; cursor: pointer" />
                              </div>
                            </div>

                            <h6 class="mb-0 pt-2 text-center text-name" (click)="goToProfileDetail()">
                              {{ productData?.appUser?.profileCharacterName || "Anonymous" }}
                            </h6>
                            <div class="d-flex flex-column">
                              <small>Level {{ productData?.appUser?.level || "0" }} ({{ productData?.appUser?.supporters }} supporters)</small>
                            </div>
                          </div>
                          <div class="text-left mt-1">
                            <p style="line-height: 14px; font-size: 16px; text-transform: none">
                              {{ productData?.appUser?.shortDescription || "" }}
                            </p>

                            <div class="d-flex flex-wrap mt-3" style="gap: 2px">
                              <span *ngIf="productData?.appUser?.regionName">
                                <div class="badge-purple">{{ productData?.appUser?.regionName }}</div>
                              </span>
                              <ng-container *ngIf="productData?.appUser && isArray(productData?.appUser?.certified)">
                                <span class="badge-purple" *ngFor="let item of productData?.appUser?.certified">
                                  {{ item }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!productData?.enableMemberShop && productData?.seller?.shop_logo">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink()" style="cursor: pointer" src="{{ !productData?.seller?.shop_logo ? '../../../assets/images/new/badge.png' : imgUrl + productData?.seller?.shop_logo }}" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink()" *ngIf="isLogin">
                          {{ productData?.seller?.shop_name ?? "-" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.seller?.shop_description ?? ''"></div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="productData?.type == 'promote' && productData?.shoutImage && productData?.shoutName">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink(true)" style="cursor: pointer" [src]="imgUrl + productData?.shoutImage" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink(true)">
                          {{ productData?.shoutName && productData?.shoutName != "null" ? productData?.shoutName : "" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.shoutDescription && productData?.shoutDescription != 'null' ? productData?.shoutDescription : ''"></div>
                      </div>
                    </ng-container>
                    <div class="mt-2">
                      <div class="d-flex w-100" *ngIf="screenWidth > 767 && productData?.enableMemberShop">
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck) ? 'var(--primary)' : 'inherit'" class="w-100">
                          <span class="w-100 d-flex justify-content-center text-white small" *ngIf="productData?.type == 'promote' && (productData?.shoutContactRelation | nullCheck)" style="margin-top: 6px">{{ productData?.shoutContactRelation | nullCheck }}</span>
                          <button style="background-color: var(--primary)" *ngIf="productData?.type != 'promote'" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled && (!productData?.shoutContact || productData?.shoutContact == '65null')">
                            <button *ngIf="showChatNow" ngbDropdownItem (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</button>
                            <button *ngIf="!productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1" ngbDropdownItem (click)="openBookNowBox()"><i class="fa-solid fa-comment-dots"></i> Book Now ({{ remainingClickBook() }})</button>
                            <button *ngIf="productData?.isOwner" ngbDropdownItem><i class="fa-brands fa-whatsapp"></i> {{ productData.remainingBookTimes }} Bookings Left</button>
                            <button *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                            <button ngbDropdownItem (click)="handleTelegram(productData.id)" *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i class="fa-brands fa-telegram"></i> Book Driver</button>
                            <button ngbDropdownItem *ngIf="showTelegramButton" (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i class="fa-brands fa-telegram"></i> Telegram</button>
                          </div>
                        </div>
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type == 'promote' && productData?.shoutContact ? 'var(--primary)' : 'inherit'" class="w-100">
                          <button style="background-color: var(--primary)" *ngIf="productData?.shoutContact" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled">
                            <button *ngIf="productData?.shoutContact" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                          </div>
                        </div>
                        <div class="dropdown-product ml-auto" *ngIf="isLogin == 1">
                          <div class="my-btn-list" *ngIf="roleService.roles?.level?.includes('MEMBER_VERIFIED_USER')" (click)="productData.showDropdown = !productData.showDropdown">
                            <i class="fa-solid fa-ellipsis-v text-dark"></i>
                          </div>
                          <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white" (mouseleave)="productData.showDropdown = false">
                            <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
                            <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
                            <div class="dropdown-product-detail__item" (click)="handleHideProduct()" *ngIf="productData?.showDropdown && productData?.enableMemberShop"><i class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
                            <ng-container *ngIf="productData?.enableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
                              <div class="dropdown-product-detail__item" (click)="editMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i> Edit</div>
                              <div class="dropdown-product-detail__item" (click)="deleteMemberProduct(productData?.id)" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i class="fa fa-trash"></i> Delete</div>

                              <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-paperclip"></i> Attach</div>
                              <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()" *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey"><i class="fa fa-trash"></i> Delete Attach</div>
                              <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share Service</div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <small class="text-danger" *ngIf="productData?.errorChatURL">Contact Seller Via Other Methods</small>
                    </div>
                  </div>
                  <div tab4>
                    <div class="socials">
                      <b class="mt-4" *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.fbReviewUrl">Reviews</b>
                      <section *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.googleReviewRating || productData?.sellerInformation?.googleReviewCount">
                        <a [href]="'http://' + sellerInformation?.googleReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.googleReviewRating + " Star" || "") +
                              " Google
                          " +
                              (productData?.sellerInformation?.googleReviewCount ? "(" + productData?.sellerInformation?.googleReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <section *ngIf="productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.carousellReviewRating || productData?.sellerInformation?.carousellReviewCount">
                        <a [href]="'http://' + sellerInformation?.carousellReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.carousellReviewRating + " Star" || "") +
                              "Carousell
                          " +
                              (sellerInformation?.carousellReviewCount ? "(" + productData?.sellerInformation?.carousellReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <section *ngIf="productData?.sellerInformation?.fbReviewUrl || productData?.sellerInformation?.fbReviewRating || productData?.sellerInformation?.fbReviewCount">
                        <a [href]="'http://' + sellerInformation?.fbReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.fbReviewRating + " Star" || "") +
                              "
                          Facebook " +
                              (productData?.sellerInformation?.fbReviewCount ? "(" + productData?.sellerInformation?.fbReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <ng-container *ngIf="productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl">
                        <br />
                        @if (productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl) {
                        <b>Socials</b>
                        }
                        <ng-container *ngIf="productData?.sellerInformation?.websiteUrl"><br /><a [href]="'http://' + productData?.sellerInformation?.websiteUrl" target="_blank">Website</a></ng-container>
                        <ng-container *ngIf="productData?.sellerInformation?.instagramUrl"> <br /><a [href]="'http://' + productData?.sellerInformation?.instagramUrl" target="_blank">Instagram</a></ng-container>
                        <ng-container *ngIf="productData?.sellerInformation?.fbUrl"><br /><a *ngIf="productData?.sellerInformation?.fbUrl" [href]="'http://' + productData?.sellerInformation?.fbUrl" target="_blank">Facebook</a></ng-container>
                        <br />
                      </ng-container>
                      <ng-container *ngIf="!productData?.enableMemberShop">
                        <b class="mt-4"> Seller Info </b>
                        <br />{{ productData?.sellerInformation?.sellerInfo || defaultSellerMsg }}
                      </ng-container>
                    </div>
                  </div>
                  <div tab3>
                  <ngb-datepicker
                    #dp
                    [minDate]="{
                      year: today.getFullYear(),
                      month: today.getMonth() + 1,
                      day: today.getDate() + 1
                    }"
                    [dayTemplate]="datePicker"
                    outsideDays="hidden"
                  >
                  </ngb-datepicker>
                  <ng-template #datePicker let-date="date" let-focused="focused">
                    <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
                      {{ date.day }}
                    </div>
                  </ng-template>
                </div>
                </app-my-tabs>
              </div> -->
            </div>

            <div class="add_cart mt-4 mb-4">
              <a class="go_to_cart_btn" *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.referralLink" (click)="openMemberLinkPopup($event, memberLinkPopup, productData?.edit_product_id, 'referral')"> Referral Link </a>
              <a class="add_to_cart_btn mt-2" *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.storeLink" (click)="openMemberLinkPopup($event, memberLinkPopup, productData?.edit_product_id, 'store')"> Store Link </a>
            </div>

            <ng-container *ngFor="let item of productData?.productVerficationsList">
              <div *ngIf="item != ''" class="product-verfications">
                <div class="product-verfications__left">
                  @if (item?.isGolden) {
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <filter id="gold-glow" x="-50%" y="-50%" width="200%" height="200%">
                          <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
                          <feOffset dx="0" dy="0" result="offsetBlur" />
                          <feFlood flood-color="#FFD700" result="color" />
                          <feComposite in="color" in2="offsetBlur" operator="in" result="glow" />
                          <feMerge>
                            <feMergeNode in="glow" />
                            <feMergeNode in="SourceGraphic" />
                          </feMerge>
                        </filter>
                      </defs>

                      <!-- Star with bright gold and glow -->
                      <path d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" fill="#FFD700" filter="url(#gold-glow)" stroke="none" />

                      <!-- White check mark -->
                      <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  } @else {
                    <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" fill="var(--primary)" stroke="none" />
                      <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  }
                  <h3 class="text">{{ item.value }}</h3>
                </div>

                <button [class.glow-less]="item.likeCounts" [class.reaction-liked]="item.haveILiked" (click)="toggleVerifyLike(item, productData)">
                  <i class="fa fa-thumbs-up"></i>
                  @if (item.likeCounts) {
                    <span class="number"><span>X</span>{{ item.likeCounts }}</span>
                  }
                </button>
              </div>
            </ng-container>
            <!-- suggestions -->
            <div class="mt-4 tabs-suggestions position-relative">
              <div class="position-absolute" style="left: 100%">
                <button class="t-btn" (click)="isAddPromoVisible = !isAddPromoVisible">
                  <i class="fa fa-ellipsis-v"></i>
                  <div class="position-absolute" style="bottom: 100%; right: 100%" *ngIf="isAddPromoVisible">
                    <button class="p-2 rounded" style="background-color: var(--white); border: 1px solid var(--secondary); width: 10em; color: var(--secondary)" (click)="$event.stopPropagation(); openAdInProductModal(productData)" (clickOutside)="isAddPromoVisible = false"><i class="fa fa-star"></i> Add Promo In This Product</button>
                  </div>
                </button>
              </div>

              <app-my-tabs [tabs]="productData?.tabsRecommend" *ngIf="productData?.tabsRecommend?.length" design="5">
                <div tab0>
                  <app-marketplace-recommendation (addClick)="showLoginError('review')" *ngIf="productData" [productData]="productData" (changeRecommend)="handleChangeRecommend(productData, $event)"></app-marketplace-recommendation>
                </div>
                <div tab1 class="more-services">
                  <ng-container *ngFor="let item of productData?.productMoreServices">
                    <div class="more-services__card" *ngIf="item && item.serviceComment" (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription) : ''">
                      <div class="more-services__card--left">
                        <svg class="shape one" viewBox="0 0 7 18" fill="none">
                          <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#CC94B2" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape two" viewBox="0 0 7 18" fill="none">
                          <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#EEB8A5" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape three" viewBox="0 0 7 18" fill="none">
                          <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#D9D9D9" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape four" viewBox="0 0 7 18" fill="none">
                          <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#D0CFD7" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape five" viewBox="0 0 19 16" fill="none">
                          <path d="M0.274837 7.03496C7.05256 7.79001 9 0 9 0C9 0 11.5 7.9 18.5 6.5C13.5 7.5 9 15.5 9 15.5C9 15.5 8.51083 8.16245 0.274837 7.03496C0.184093 7.02485 0.0924827 7.01321 0 7C0.0925576 7.01089 0.184167 7.02255 0.274837 7.03496Z" fill="#E4719A" fill-opacity="0.25" />
                        </svg>

                        @if (item.allowRefer) {
                          <div class="more-services__card--left__price">
                            {{ !item.referAmount || item.referAmount == "0" ? "FREE" : "$" + item.referAmount }}
                          </div>
                        }
                        <div class="more-services__card--left__comment">{{ item.serviceComment }}</div>
                        @if (item.allowRefer) {
                          @if (!profileInfo2?.linkReferedCount && !linkRfererUserId && isLogin) {
                            <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
                          } @else {
                            @if (isLogin) {
                              <button (click)="$event.stopPropagation(); claimMoreService(item)" class="my-button-3 below-btn">Claim</button>
                            } @else {
                              <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Login</button>
                            }
                          }
                        }
                      </div>

                      <div class="more-services__card--right">
                        <svg viewBox="0 0 53 190" fill="none">
                          <path d="M51.9999 0L-4.95911e-05 0L-4.95911e-05 189.5L26 149C30 143.5 51.4646 112.825 37.9823 107C24.5 101.175 4.09374 108.545 5.5 92.5C6.90626 76.455 54.2432 19.6542 51.9999 0Z" fill="#fff" />
                        </svg>

                        <img class="more-services__card--right__image" [src]="imgUrl + item.imageFile" (error)="handleError($event)" />
                        @if (item.iconText?.trim()) {
                          <div style="position: absolute; top: 0; right: 0.5rem">
                            <app-icon-selector [nowValue]="item.iconText" [icons]="[]" [selectionEnabled]="false"></app-icon-selector>
                          </div>
                        }
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div tab2>
                  <div style="max-width: 20rem; margin: auto">
                    <div class="d-flex w-100 justify-content-center mt-3 align-items-center" style="color: var(--primary); flex-wrap: wrap">
                      <div *ngIf="productData?.seller_info?.fbUrl" class="">
                        <a [href]="correctSite(productData?.seller_info?.fbUrl)" target="_blank"> <i class="fa-brands fa-facebook-f"></i></a>
                      </div>
                      <div *ngIf="productData?.seller_info?.instagramUrl" class="mr-3 ml-3">
                        <a [href]="correctSite(productData?.seller_info?.instagramUrl)" target="_blank">
                          <i class="fa-brands fa-instagram"></i>
                        </a>
                      </div>

                      <div *ngIf="productData?.seller_info?.websiteUrl" class="d-flex mr-2">
                        <span
                          ><a [href]="correctSite(productData?.seller_info?.websiteUrl)" target="_blank" style="color: var(--primart)"> <i class="fa-solid fa-globe"></i> </a
                        ></span>
                      </div>
                    </div>
                    <ng-container *ngIf="productData?.type != 'promote' || (productData?.type == 'promote' && (!productData?.shoutImage || !productData?.shoutName))">
                      <!-- Hover User Info  -->
                      <popper-content #tooltipcontent>
                        <div class="popper-content">
                          <app-biz-owner-popup *ngIf="productData?.memberId" [inputId]="productData?.memberId"></app-biz-owner-popup>
                        </div>
                      </popper-content>
                      <!-- Hover User Info  -->
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body">
                          <div class="text-center">
                            <div class="d-flex justify-content-center">
                              <i class="fa-solid fa-calendar" (click)="openHolidayPopUp(HolidayPopup)" style="position: relative; left: 7rem; color: #cc6767"></i>

                              <div style="position: absolute; left: 1.25rem">
                                <div class="d-flex flex-column">
                                  <ng-container *ngFor="let item of productData?.appUser?.appUserCertificates; let i = index">
                                    <img loading="lazy" src="{{ imgUrl }}public/images/certificate/{{ item.role }}.png" style="height: 1.5rem; width: 1.5rem; border-radius: 50%" />
                                  </ng-container>
                                </div>
                              </div>
                              <div>
                                <img loading="lazy" (click)="goToProfileDetail()" [popper]="tooltipcontent" [popperTrigger]="screenWidth > 767 ? 'hover' : 'click'" [popperPlacement]="'right'" src="{{ local.checkImageProfile(productData?.appUser) }}" class="shadow-sm rounded-circle border char-image" style="width: 85px; height: 85px; cursor: pointer" />
                              </div>
                            </div>

                            <h6 class="mb-0 pt-2 text-center text-name" (click)="goToProfileDetail()">
                              {{ productData?.appUser?.profileCharacterName || "Anonymous" }}
                            </h6>
                            <div class="d-flex flex-column">
                              <!-- <small *ngIf="productData?.appUser?.regionName" class="text-primary">{{
                              productData?.appUser?.regionName }}</small> -->
                              <small>Level {{ productData?.appUser?.level || "0" }} ({{ productData?.appUser?.supporters }} supporters) <span class="badge-pink" style="cursor: pointer" (click)="handleSupportSeller()">+ Friend</span></small>
                            </div>
                          </div>
                          <div class="text-left mt-1">
                            <p style="line-height: 14px; font-size: 16px; text-transform: none" *ngIf="productData?.appUser?.shortDescription != 'null'">
                              {{ productData?.appUser?.shortDescription || "" }}
                            </p>

                            <div class="d-flex flex-wrap mt-3" style="gap: 2px">
                              <span *ngIf="productData?.appUser?.regionName">
                                <div class="badge-purple">{{ productData?.appUser?.regionName }}</div>
                              </span>
                              <ng-container *ngIf="productData?.appUser && isArray(productData?.appUser?.certified)">
                                <span class="badge-purple" *ngFor="let item of productData?.appUser?.certified">
                                  {{ item }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!productData?.mainProductEnableMemberShop && productData?.seller?.shop_logo">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink()" style="cursor: pointer" src="{{ !productData?.seller?.shop_logo ? '../../../assets/images/new/badge.png' : imgUrl + productData?.seller?.shop_logo }}" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink()" *ngIf="isLogin">
                          {{ productData?.seller?.shop_name ?? "-" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.seller?.shop_description ?? ''"></div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="productData?.type == 'promote' && productData?.shoutImage && productData?.shoutName">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink(true)" style="cursor: pointer" [src]="imgUrl + productData?.shoutImage" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink(true)">
                          {{ productData?.shoutName && productData?.shoutName != "null" ? productData?.shoutName : "" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.shoutDescription && productData?.shoutDescription != 'null' ? productData?.shoutDescription : ''"></div>
                      </div>
                    </ng-container>
                    <div class="mt-2">
                      <div class="d-flex w-100" *ngIf="screenWidth > 767 && mainProductEnableMemberShop">
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck) ? 'var(--primary)' : 'inherit'" class="w-100">
                          <span class="w-100 d-flex justify-content-center text-white small" *ngIf="productData?.type == 'promote' && (productData?.shoutContactRelation | nullCheck)" style="margin-top: 6px">{{ productData?.shoutContactRelation | nullCheck }}</span>
                          <button style="background-color: var(--primary)" *ngIf="productData?.type != 'promote'" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled && (!productData?.shoutContact || productData?.shoutContact == '65null')">
                            <button *ngIf="showChatNow" ngbDropdownItem (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</button>
                            <button *ngIf="!productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1" ngbDropdownItem (click)="openBookNowBox()"><i class="fa-solid fa-comment-dots"></i> Book Now ({{ remainingClickBook() }})</button>
                            <button *ngIf="productData?.isOwner" ngbDropdownItem><i class="fa-brands fa-whatsapp"></i> {{ productData.remainingBookTimes }} Bookings Left</button>
                            <button *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                            <button ngbDropdownItem (click)="handleTelegram(productData.id)" *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i class="fa-brands fa-telegram"></i> Book Driver</button>
                            <button ngbDropdownItem *ngIf="showTelegramButton" (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i class="fa-brands fa-telegram"></i> Telegram</button>
                          </div>
                        </div>
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type == 'promote' && productData?.shoutContact ? 'var(--primary)' : 'inherit'" class="w-100">
                          <button style="background-color: var(--primary)" *ngIf="productData?.shoutContact" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled">
                            <button *ngIf="productData?.shoutContact" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                          </div>
                        </div>

                        <div class="dropdown-product ml-auto" *ngIf="isLogin == 1">
                          <div class="my-btn-list" *ngIf="roleService.roles?.userType?.includes('ADMIN') || productData?.memberId == profileInfo2?.id" (click)="productData.showDropdown = !productData.showDropdown">
                            <i class="fa-solid fa-ellipsis-v text-dark"></i>
                          </div>
                          <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white" (mouseleave)="productData.showDropdown = false">
                            <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
                            <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
                            <div class="dropdown-product-detail__item" (click)="handleHideProduct()" *ngIf="productData?.showDropdown && mainProductEnableMemberShop"><i class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
                            <ng-container *ngIf="mainProductEnableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
                              <div class="dropdown-product-detail__item" (click)="editMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i> Edit</div>
                              <div class="dropdown-product-detail__item" (click)="deleteMemberProduct(productData?.id)" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i class="fa fa-trash"></i> Delete</div>

                              <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-paperclip"></i> Attach</div>
                              <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()" *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey"><i class="fa fa-trash"></i> Delete Attach</div>
                              <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share Service</div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <small class="text-danger" *ngIf="productData?.errorChatURL">Contact Seller Via Other Methods</small>
                    </div>
                    <!-- <div class="d-flex justify-content-center" style="gap: 0.5em; margin: 0.5rem 0; padding-top: 0.5rem; border-top: 1px solid rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.15)">
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Quick replies</button>
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Worth the cost</button>
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Certified or experienced</button>
                    </div> -->
                  </div>
                </div>
                <div tab3>
                  <app-marketplace-forum *ngIf="mainProductEnableMemberShop && productData?.forum" [productForum]="productData?.forum" [hideNonEssential]="true"></app-marketplace-forum>
                </div>
                <div tab4>
                  <div class="row product_detail_promo px-2">
                    <div class="col-6 p-0" *ngFor="let row of productData?.more_products_data">
                      <div class="card mb-3 border-0 h-100" (click)="redirectToProduct(row)">
                        <div class="d-flex flex-column no-gutters">
                          <div class="container-img">
                            <img loading="lazy" src="{{ imgUrl }}{{ row?.foodImages ? row?.foodImages[0].image : row?.memberShopProductsImages[0].image }}" class="border-0 p-0 w-100" alt="..." />
                          </div>
                          <div class="pl-2 pt-1">
                            <p style="font-size: 13px; line-height: 13px" class="font-bold">
                              {{ row.name }}
                            </p>
                            <div>
                              <p class="price" style="font-size: 13px; line-height: 13px">${{ row.foodSpecs ? row.foodSpecs[0].key : row.memberShopProductsVariations[0].key }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div tab5>
                  <div class="socials">
                    <b class="mt-4" *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.fbReviewUrl">Reviews</b>
                    <section *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.googleReviewRating || productData?.sellerInformation?.googleReviewCount">
                      <a [href]="'http://' + sellerInformation?.googleReviewUrl" target="_blank">
                        {{
                          (productData?.sellerInformation?.googleReviewRating + " Star" || "") +
                            " Google
                        " +
                            (productData?.sellerInformation?.googleReviewCount ? "(" + productData?.sellerInformation?.googleReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <section *ngIf="productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.carousellReviewRating || productData?.sellerInformation?.carousellReviewCount">
                      <a [href]="'http://' + sellerInformation?.carousellReviewUrl" target="_blank">
                        {{
                          (productData?.sellerInformation?.carousellReviewRating + " Star" || "") +
                            "Carousell
                        " +
                            (sellerInformation?.carousellReviewCount ? "(" + productData?.sellerInformation?.carousellReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <section *ngIf="productData?.sellerInformation?.fbReviewUrl || productData?.sellerInformation?.fbReviewRating || productData?.sellerInformation?.fbReviewCount">
                      <a [href]="'http://' + sellerInformation?.fbReviewUrl" target="_blank">
                        {{
                          (productData?.sellerInformation?.fbReviewRating + " Star" || "") +
                            "
                        Facebook " +
                            (productData?.sellerInformation?.fbReviewCount ? "(" + productData?.sellerInformation?.fbReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <ng-container *ngIf="productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl">
                      <br />
                      @if (productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl) {
                        <b>Socials</b>
                      }
                      <ng-container *ngIf="productData?.sellerInformation?.websiteUrl"><br /><a [href]="'http://' + productData?.sellerInformation?.websiteUrl" target="_blank">Website</a></ng-container>
                      <ng-container *ngIf="productData?.sellerInformation?.instagramUrl"> <br /><a [href]="'http://' + productData?.sellerInformation?.instagramUrl" target="_blank">Instagram</a></ng-container>
                      <ng-container *ngIf="productData?.sellerInformation?.fbUrl"><br /><a *ngIf="productData?.sellerInformation?.fbUrl" [href]="'http://' + productData?.sellerInformation?.fbUrl" target="_blank">Facebook</a></ng-container>
                      <br />
                    </ng-container>
                    <ng-container *ngIf="!mainProductEnableMemberShop">
                      <b class="mt-4"> Seller Info </b>
                      <br />{{ productData?.sellerInformation?.sellerInfo || defaultSellerMsg }}
                    </ng-container>
                  </div>
                </div>
                <div tab6>
                  <app-product-faq-list [additionalFAQS]="productData?.faqInfos" [categoryId]="-1"></app-product-faq-list>
                </div>
                <!-- <div tab4>
                  <ngb-datepicker
                    #dp
                    [minDate]="{
                      year: today.getFullYear(),
                      month: today.getMonth() + 1,
                      day: today.getDate() + 1
                    }"
                    [dayTemplate]="datePicker"
                    outsideDays="hidden"
                  >
                  </ngb-datepicker>
                  <ng-template #datePicker let-date="date" let-focused="focused">
                    <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
                      {{ date.day }}
                    </div>
                  </ng-template>
                </div> -->
              </app-my-tabs>
            </div>

            <div *ngIf="roleService?.roles?.userType?.includes('ADMIN')" style="color: var(--secondary)" class="m-3">Login Because of product: {{ productData?.loginBecauseOfProductCount + "" }}</div>
            <div *ngIf="isLogin == 0 && mainProductEnableMemberShop && showLoginErr">
              <div class="alert alert-danger mt-2" role="alert" id="login-err">
                <div class="d-flex flex-column flex-md-row justify-content-between">
                  <span class="my-auto"> <i class="fa-solid fa-exclamation-circle"></i> Please log in first if you want to {{ loginErrorReason }}. </span>
                  <button class="btn btn-sm btn-primary" (click)="loginHere()">Login Here !</button>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  
</ng-template>
<div class="modal-footer fixed-position" *ngIf="screenWidth < 767" [class.p-0]="!isLogin">
  <div class="content d-flex flex-column" style="gap: 1em">
    <div *ngIf="!isUserDisabled && !productData?.seller?.isDisabled && productData?.type !== 'promote'">
      <button *ngIf="showChatNow" class="button-3 secondary" (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</button>
      <button class="button-3" *ngIf="isLogin && !productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1" (click)="openBookNowBox()"><i class="fa-brands fa-whatsapp"></i> Book now ({{ remainingClickBook() }})</button>
      <button class="button-3" *ngIf="isLogin && productData?.isOwner"><i class="fa-brands fa-whatsapp"></i> {{ productData?.remainingBookTimes }} Bookings Left</button>
      <button class="button-3 success" *ngIf="isLogin && (productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number" (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
      <button class="button-3 mt-3" (click)="handleTelegram(productData?.id)" *ngIf="isLogin && productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i class="fa-brands fa-telegram"></i> Book Driver</button>
      <button class="button-3 mt-3" *ngIf="isLogin && showTelegramButton" (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i class="fa-brands fa-telegram"></i> Chat on Telegram</button>
    </div>
    <div *ngIf="isLogin && !isUserDisabled && !productData?.seller?.isDisabled && productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)">
      <button class="button-3 success" *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number" (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
    </div>
    <div class="bottom-actions" *ngIf="!isLogin">
      <button class="mr-3 open-bookmarks-btn"  (click)="openSaveBookMarks()">
        {{ bookmarkedProductsIds.size }}/10
        <i class="fa fa-book ml-1"></i>
      </button>

      <div class="d-flex mr-2 align-items-center">
        <input type="checkbox" style="accent-color: red" [checked]="!bookmarkedProductsIds.has(productData?.id)" 
        [id]="'notinterested-' + productData?.name" (click)="$event.target.checked ?  removeProductFromBookmarks(productData) : addProductToBookmarks(productData)  "/>
        <label class="m-0 ml-2" [for]="'notinterested-' + productData?.name" style="color: red;">Not Interested</label>
      </div> 
      <div class="d-flex align-items-center">
        <input type="checkbox"  style="accent-color: green" (click)="$event.target.checked ?  addProductToBookmarks(productData) : removeProductFromBookmarks(productData)  " [checked]="bookmarkedProductsIds.has(productData?.id)" [id]="'interested-' + productData?.name"/>
        <label class="m-0 ml-2" [for]="'interested-' + productData?.name" style="color: green;">Interested</label>
      </div> 


      <!-- <a style="color: var(--secondary); " [href]="'https://wa.me/' + productData?.shoutContact" target="_blank"> 
        <i class="fa-brands fa-whatsapp" style="font-size: 1.1rem"></i> WhatsApp </a> -->
    </div>
    <div class="dropdown-product menu-top ml-auto" *ngIf="isLogin == 1">
      <div class="my-btn-list" *ngIf="roleService.roles?.level?.includes('MEMBER_VERIFIED_USER')" (click)="productData.showDropdown = !productData?.showDropdown">
        <i class="fa-solid fa-ellipsis-v text-dark"></i>
      </div>
      <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white" (mouseleave)="productData.showDropdown = false">
        <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
        <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
        <div class="dropdown-product-detail__item" (click)="handleHideProduct()" *ngIf="productData?.showDropdown && mainProductEnableMemberShop"><i class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
        <ng-container *ngIf="mainProductEnableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
          <div class="dropdown-product-detail__item" (click)="editMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i> Edit</div>
          <div class="dropdown-product-detail__item" (click)="deleteMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i class="fa fa-trash"></i> Delete</div>
        </ng-container>
        <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-trash"></i> Attach</div>
        <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey"><i class="fa fa-trash"></i> Delete Attach</div>
        <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share Product</div>
      </div>
    </div>
  </div>
</div>

<ng-template #AttachMemberProduct let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Attach Product</h2>
    <div style="color: var(--primary)">Product</div>
    <section class="attach">
      <div class="attach__card" *ngFor="let list of memberProductList">
        <common-product-card-view [list]="list" [isCommunityProduct]="true"></common-product-card-view>
        <div class="attach__card--option">
          <select class="form-control" [(ngModel)]="endTime">
            <option value="30">30 Days</option>
            <option value="60">60 Days</option>
            <option value="">Endless</option>
          </select>
          <button class="my-button-3 secondary" (click)="attachProduct(list?.id)"><i class="fa-solid fa-save"></i>Attach</button>
        </div>
      </div>
    </section>
  </div>
</ng-template>

<ng-template #reportsPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Report</h2>
    <div class="mt-2 mb-1" style="color: var(--primary)">Report Something Suspicious :</div>

    <div class="form-group">
      <label for="">Report Type</label>
      <select [(ngModel)]="reportType" id="" class="form-control">
        <option value="Spam">Spam</option>
        <option value="Wrong Info">Wrong Info</option>
        <option value="Repeated">Repeated</option>
        <option value="Out of business">Out of business</option>
        <option value="Offensive language">Offensive language</option>
        <option value="Offensive image">Offensive image</option>
        <option value="Seller Unresponsive">Seller Unresponsive</option>
        <option value="Seller is Rude">Seller is Rude</option>
        <option value="Seller is a Lowballer">Seller is a Lowballer</option>
      </select>
    </div>
    <div class="form-group">
      <textarea class="form-control" placeholder="Enter details" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
    </div>
    <button class="d-flex ml-auto my-button-3" (click)="submitReport()">Submit <i class="fa fa-gavel" aria-hidden="true"></i></button>
  </div>
</ng-template>

<ng-template #memberLinkPopup let-modal>
  <div class="modal-body referral-modal">
    <div class="add_cattt">
      <h2>MEMBER INFO</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <!-- <div class="gold-membership">
        <div>
          <img loading="lazy" src="../../../../assets/images/GoldMember.png" alt="img">
          <p>Gold</p>
        </div>
      </div> -->
    <div class="referral-link">
      <h6>
        <span *ngIf="isTypeReferral == 'referral'">REFERRAL LINK</span>
        <span *ngIf="isTypeReferral == 'store'">PROFILE LINK</span>
      </h6>
      <div class="">
        <a class="referral-title" href="{{ refer_friend_link }}" target="_blank">
          <p class="ref_link">{{ refer_friend_link }}</p>
        </a>
      </div>
      <div class="mt-4">
        <div class="cart_btn">
          <a class="confirm_button" (click)="copyReferralLink()">
            <img loading="lazy" src="../../../../assets/images/copy-icon.svg" alt="img" />
            Copy</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #suggestionsPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Suggestions</h2>
    <div class="form-group">
      <textarea class="form-control" placeholder="Enter Your Suggestions" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
    </div>
    <button class="d-flex ml-auto my-button-3" (click)="submitSuggestion()">Submit <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
  </div>
</ng-template>

<ng-template #HolidayPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="holiday-header">Holiday</h2>
    <div class="holiday-container">
      <ngb-datepicker
        #dp
        [minDate]="{
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          day: today.getDate() + 1,
        }"
        [dayTemplate]="datePicker"
        outsideDays="hidden"
      >
      </ngb-datepicker>
      <ng-template #datePicker let-date="date" let-focused="focused">
        <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
          {{ date.day }}
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
